<template>
    <div>
      首页
    </div>
</template>

<script>
    export default {
        name: "HomePage"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/HomePage.vue